import * as d3 from "d3";
import { useUser } from "../../../services/auth";

export const aggregatedQuestionTypes = {
  numeric: ["numeric", "ranking"],
  categorical: ["categorical", "scale0_10", "scale1_10"],
};

export const indexToColor = (index: number) => {
  return d3.schemeCategory10[index % 10];
};

export const useHasVirtualVariablePermission = () => {
  const user = useUser();
  const hasAccess = user?.groups?.includes("ADMIN");
  return hasAccess;
};
